import CompanyServiceListView from "@/views/company/services/CompanyServiceListView";
import CompanyServiceCreateView from "@/views/company/services/CompanyServiceCreateView";
import CompanyServiceEditView from "@/views/company/services/CompanyServiceEditView";

export default [
  {
    name: "pages.company.services",
    path: "services",
    component: CompanyServiceListView
  },
  {
    name: "pages.company.services.create",
    path: "services/create",
    component: CompanyServiceCreateView
  },
  {
    name: "pages.company.services.edit",
    path: "services/:id/edit",
    component: CompanyServiceEditView
  },
];
